<template>
  <form class="page-container" @submit.prevent="addOrUpdateCertificate">
    <h2 class="text-center">{{ editMode ? "Edit" : "Add New" }} Certificate</h2>
    <div class="p-4 pb-0">
      <label for="name">Certificate Name</label>
      <input
        id="name"
        v-model="name"
        required
        class="w-full mt-2"
        type="text"
      />
    </div>
    <div class="p-4 pb-0">
      <label for="cohort-id">Cohort Id</label>
      <VueSelect
        v-model="cohortName"
        placeholder="Select Cohort"
        label="name"
        :options="cohortList"
        :reduce="cohort => cohort.name"
        @change="handleChange"
      />
    </div>
    <div class="p-4 pb-0 flex items-center">
      <label for="enable">Enable Certificate</label>
      <input
        id="enable"
        v-model="certificateEnable"
        type="checkbox"
        class="ml-4"
      />
    </div>
    <div class="text-right p-4">
      <button
        type="submit"
        class="text-right bg-green hover:bg-green-dark px-4 py-2 text-white"
      >
        {{ editMode ? "Update" : "Add" }}
      </button>
    </div>
  </form>
</template>

<script>
import VueSelect from "vue-select"
import siteConfig from "@/utils/siteConfig"

export default {
  components: {
    VueSelect,
  },
  data() {
    return {
      name: "",
      cohortId: null,
      cohortName: "", // just for displaying
      certificateEnable: false,
      cohortList: [],
      editMode: false,
      certificateId: "",
    }
  },
  created() {
    if (this.$route.params && this.$route.params.id) {
      this.editMode = true
      this.fetchCertificate()
    } else {
      this.getCohorts()
    }
  },
  methods: {
    fetchCertificate() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}admin/certificates/${this.$route.params.id}`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        const { certificate } = res.data
        this.name = certificate.name
        this.certificateEnable = certificate.certificate_enabled
        this.certificateId = certificate.id
        this.cohortId = certificate.cohort_id
        this.getCohorts()
      })
    },
    getCohorts() {
      this.axios({
        method: "get",
        url: `${siteConfig.siteURL}cohorts/?pagination=false`,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        this.cohortList = res.data.items
        if (this.editMode) {
          const cohort = this.cohortList.find(c => c.id === this.cohortId)
          if (cohort) {
            this.cohortId = cohort.id
            this.cohortName = cohort.name
          }
        }
      })
    },
    addOrUpdateCertificate() {
      if (!this.cohortId && !this.name) {
        return
      }
      let url = `${siteConfig.siteURL}admin/certificates`
      let method = "POST"
      const data = {
        name: this.name,
        certificate_enabled: this.certificateEnable,
        cohort_id: this.cohortId,
      }

      if (this.editMode) {
        url = `${siteConfig.siteURL}admin/certificates/${this.certificateId}`
        method = "PUT"
        data.id = this.certificateId
      }

      this.axios({
        method,
        url,
        data,
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          "x-access-token": localStorage.token,
        },
      }).then(res => {
        this.$noty.success(res.data.message)
        setTimeout(() => {
          this.$router.push({ name: "CertificateList" })
        }, 1000)
      })
    },
    handleChange(option) {
      if (option && typeof option === "object") {
        this.cohortId = option.id
        this.cohortName = option.name
      }
    },
  },
}
</script>

<style scoped>
.page-container {
  width: 100%;
  max-width: 40rem;
  margin: auto;
}
</style>
